module.exports = __webpack_public_path__ + "static/img/mainTitle.8257e75.png";


//////////////////
// WEBPACK FOOTER
// ./image/homePage/mainTitle.png
// module id = 561
// module chunks = 502